export default __webpack_public_path__ + "static/media/spinner.3df0cae7.png";